import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
  SwitchItem,
  DatePickerItem,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import reporteDeCostoInventarioPdf from "../../../../Pdf/reporteDeCostoInventarioPdf";



moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteCostoInventario extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasInventario: [],
    dataGrafico: [],
    valorMaximoCirculo: 0,
    costoTotalInventario: 0,
    historico: false,
    fechaCorte: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.consultarReporteCostoInventario();
  }

  async crearGrafico(valueInventarios) {

    let valorMaximoCirculo = 0

    let grafico = valueInventarios.map(valueInventario => {

      valorMaximoCirculo = Math.max(valueInventario.cantidad, valorMaximoCirculo)

      return {
        "id": valueInventario.descripcionInsumo,
        "group": "Cantidad",
        "cantidad": valueInventario.costoPromedio,
        "volume": valueInventario.cantidad
      }
    });


    await this.setState({
      valorMaximoCirculo,
      dataGrafico: grafico,
    });
  }

  consultarReporteCostoInventario(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteCostoInventario",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.crearGrafico(
            res.data.inventario,
          );
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasInventario: res.data.inventario,
            costoTotalInventario: res.data.costoTotalInventario,
            historico: !!res.data.historico,
            fechaCorte: res.data.fechaCorte || null,
          });
        } else if (res.data.success === 0 && res.data.message) {
          message.error(res.data.message);
          this.setState({ loading: false });
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    let datosDescargar = this.state.todasInventario.map(valueInventario => {
      return {
        'Codigo': valueInventario.codigoInsumo,
        'Clave': valueInventario.claveInsumo,
        'Descripcion': valueInventario.descripcionInsumo,
        'Marca': valueInventario.nombreMarca,
        'Proyecto': valueInventario.nombreProyecto,
        'Familia': valueInventario.nombreFamilia,
        'Cantidad Disponible': valueInventario.cantidadNormal,
        'Cantidad Apartada': valueInventario.cantidadApartada,
        'Costo Promedio': valueInventario.costoPromedio,
        'Costo Total': valueInventario.costoTotal,
        ...(this.state.historico ? {} : {
          'Ultimo Costo': valueInventario.ultimoCosto,
          'Costo Total (UC)': valueInventario.costoTotalUC,
        }),
      }
    })
    const worksheet = XLSX.utils.json_to_sheet([...datosDescargar, { 'Costo Total': this.state.costoTotalInventario }]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte Costo Inventario");
    //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, `Reporte_Costo_Inventario_${moment().locale("es").format("L")}.xlsx`);
  }

  descargarPdf() {
    pdfMake
      .createPdf(reporteDeCostoInventarioPdf(this.state.dataReporte))
      .download(`Reporte_Costo_Inventario_${moment().locale("es").format("L")}`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    const columns = [
      {
        title: "Clave",
        dataIndex: "claveInsumo",
        key: "claveInsumo",
        sorter: (a, b) => {
          if (a.claveInsumo < b.claveInsumo) {
            return -1;
          }
          if (a.claveInsumo > b.claveInsumo) {
            return 1;
          }
          return 0;
        },
        buscar: "claveInsumo",
        ellipsis: true,
      },
      {
        title: "Descripcion",
        dataIndex: "descripcionInsumo",
        key: "descripcionInsumo",
        sorter: (a, b) => {
          if (a.descripcionInsumo < b.descripcionInsumo) {
            return -1;
          }
          if (a.descripcionInsumo > b.descripcionInsumo) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcionInsumo",
        ellipsis: true,
      },
      {
        title: "Familia",
        dataIndex: "nombreFamilia",
        key: "nombreFamilia",
        sorter: (a, b) => {
          if (a.nombreFamilia < b.nombreFamilia) {
            return -1;
          }
          if (a.nombreFamilia > b.nombreFamilia) {
            return 1;
          }
          return 0;
        },
        buscar: "nombreFamilia",
        ellipsis: true,
      },
      {
        title: "Marca",
        dataIndex: "nombreMarca",
        key: "nombreMarca",
        sorter: (a, b) => {
          if (a.nombreMarca < b.nombreMarca) {
            return -1;
          }
          if (a.nombreMarca > b.nombreMarca) {
            return 1;
          }
          return 0;
        },
        buscar: "nombreMarca",
        ellipsis: true,
      },
      {
        title: "Proyecto",
        dataIndex: "nombreProyecto",
        key: "nombreProyecto",
        sorter: (a, b) => {
          if (a.nombreProyecto < b.nombreProyecto) {
            return -1;
          }
          if (a.nombreProyecto > b.nombreProyecto) {
            return 1;
          }
          return 0;
        },
        buscar: "nombreProyecto",
        ellipsis: true,
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        sorter: (a, b) => {
          if (a.cantidad < b.cantidad) {
            return -1;
          }
          if (a.cantidad > b.cantidad) {
            return 1;
          }
          return 0;
        },
        buscar: "cantidad",
        render: (value) => value.toFixed(2),
        align: 'right',
        ellipsis: true,
      },
      {
        title: "Costo Prom.",
        dataIndex: "costoPromedio",
        key: "costoPromedio",
        sorter: (a, b) => {
          if (a.costoPromedio < b.costoPromedio) {
            return -1;
          }
          if (a.costoPromedio > b.costoPromedio) {
            return 1;
          }
          return 0;
        },
        buscar: "costoPromedio",
        render: (value) => dineroDisabledMask(value),
        align: 'right',
        ellipsis: true,
      },
      {
        title: "Costo Total",
        dataIndex: "costoTotal",
        key: "costoTotal",
        sorter: (a, b) => {
          if (a.costoTotal < b.costoTotal) {
            return -1;
          }
          if (a.costoTotal > b.costoTotal) {
            return 1;
          }
          return 0;
        },
        buscar: "costoTotal",
        render: (value) => dineroDisabledMask(value),
        align: 'right',
        ellipsis: true,
      },
      {
        title: "Ultimo Costo",
        dataIndex: "ultimoCosto",
        key: "ultimoCosto",
        sorter: (a, b) => {
          if (a.ultimoCosto < b.ultimoCosto) {
            return -1;
          }
          if (a.ultimoCosto > b.ultimoCosto) {
            return 1;
          }
          return 0;
        },
        buscar: "ultimoCosto",
        render: (value) => dineroDisabledMask(value),
        align: 'right',
        ellipsis: true,
        omitirHistorico: true,
      },
      {
        title: "Costo Total (U.C.)",
        dataIndex: "costoTotalUC",
        key: "costoTotalUC",
        sorter: (a, b) => {
          if (a.costoTotalUC < b.costoTotalUC) {
            return -1;
          }
          if (a.costoTotalUC > b.costoTotalUC) {
            return 1;
          }
          return 0;
        },
        buscar: "costoTotalUC",
        render: (value) => dineroDisabledMask(value),
        align: 'right',
        ellipsis: true,
        omitirHistorico: true,
      },
    ].filter((column) => !this.state.historico || !column.omitirHistorico);
    return (
      <>
        <Form
          ref={this.formRef}
          name="rerpoteCostoInventario"
          onFinish={this.consultarReporteCostoInventario.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title={
              "Reporte Inventario" +
              (this.state.historico && this.state.fechaCorte
                ? " al " + moment(this.state.fechaCorte).format("DD/MM/YYYY")
                : "") +
              ": " + dineroDisabledMask(this.state.costoTotalInventario)
            }
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="6" key="6" forceRender tab="Fecha de Corte">
                  <FormItem
                    marginBottom="0px"
                    label="Fecha de Corte"
                    name="fechaCorte"
                    tooltip="Deja este campo vacío para ver el costo de inventario actual. Selecciona una fecha para recalcularlo como si fuera ese día (máximo 1 año atrás)."
                  >
                    <DatePickerItem
                      disabledDate={(current) =>
                        current &&
                        (current > moment().endOf("day") ||
                          current < moment().subtract(1, "year").startOf("day"))
                      }
                    />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem required margin name="unidadDeNegocioId" noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="1" key="1" forceRender tab="Detalles">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        label="Separar Proyectos"
                        name="separarProyectos"
                        valuePropName="checked"
                        margin
                      >
                        <SwitchItem />
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <div style={{ height: 10 }}></div>
            {/* <div
                style={{
                  backgroundColor: "white",
                  padding: 15,
                  marginTop: 10,
                  marginBottom: 10,
                  height: "400px",
                }}
              >
                <h1 style={{ fontSize: "20px" }}>Grafico</h1>
                <ResponsiveSwarmPlot
                    data={this.state.dataGrafico}
                    groups={[ 'Cantidad']}
                    identity="id"
                    value="cantidad"
                    spacing={8}
                    gap={30}
                    valueScale={{ type: 'linear', min: 0, max: 'auto', reverse: false }}
                    size={{
                        key: 'volume',
                        values: [
                            0,
                            this.state.valorMaximoCirculo
                        ],
                        sizes: [
                            12,
                            50
                        ]
                    }}
                    forceStrength={9}
                    valueFormat={(e) => dineroDisabledMask(e)}
                    simulationIterations={100}
                    margin={{ top: 80, right: 100, bottom: 80, left: 100 }}
                    axisTop={{
                        orient: 'top',
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                    }}
                    axisRight={{
                        orient: 'right',
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                    }}
                    axisBottom={{
                        orient: 'bottom',
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                    }}
                    axisLeft={{
                        orient: 'left',
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                    }}
                    colors={['#ff6633', '#33cccc', '#cccc33']}
                    colorBy="index"
                />
              </div> */}
            <TableItem
              rowKey={(value) => value.insumoId.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasInventario}
              size="small"
              pagination={false}
            />
            {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteCostoInventario);
